import { render, staticRenderFns } from "./Screensaver.vue?vue&type=template&id=ecc75c5c&scoped=true&"
import script from "./Screensaver.vue?vue&type=script&lang=js&"
export * from "./Screensaver.vue?vue&type=script&lang=js&"
import style0 from "./Screensaver.vue?vue&type=style&index=0&id=ecc75c5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc75c5c",
  null
  
)

export default component.exports